import { render, staticRenderFns } from "./StructureEditor.vue?vue&type=template&id=57fbaf82&scoped=true"
import script from "./StructureEditor.vue?vue&type=script&lang=js"
export * from "./StructureEditor.vue?vue&type=script&lang=js"
import style0 from "./StructureEditor.vue?vue&type=style&index=0&id=57fbaf82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fbaf82",
  null
  
)

export default component.exports